@if (subTopic) {
  @if (form && subTopic.action === SUBTOPIC_ACTIONS.SHOW_FORM) {
    <form-contact
      [form]="form"
      [countries$]="countries$"
      [businessTypes$]="businessTypes$"
      [stateRegions$]="stateRegions$"
      (_onSubmit)="submit()"
    ></form-contact>
  }

  @if (subTopic.action === SUBTOPIC_ACTIONS.REQUIRE_LOGIN) {
    <request-login></request-login>
  }

  @if (subTopic.action === SUBTOPIC_ACTIONS.CONTENT) {
    <div [innerHTML]="subTopic.content | safeHtml"></div>
  }

  @if (subTopic.action === SUBTOPIC_ACTIONS.REQUIRE_LOGIN_WITH_CONTENT) {
    @if(subTopic.content) {
      <div class="content-before" [innerHTML]="subTopic.content | safeHtml"></div>
    }

    <request-login></request-login>

    @if(subTopic.contentAfter) {
      <div class="content-after" [innerHTML]="subTopic.contentAfter | safeHtml"></div>
    }
  }
}